import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MenuItem } from "primeng/api";
import { SubSink } from "subsink";
import { AuthenticationService } from "../services/authentication.service";
import { RosterSettingsService } from "../services/roster-settings.service";
import { BusinessOperation } from "../shared/models/business-operation";
import { IRosterSettings } from "../shared/models/roster/roster-settings";

@Component({
  selector: "pps-manage-roster-settings",
  templateUrl: "./manage-roster-settings.component.html",
  styles: [`
    .roster-setting .p-tabview{
      height:calc(100% - 74px);
    }
    .roster-setting .p-tabview-panel, 
    .roster-setting .p-tabview-panels{
      height:100%;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class ManageRosterSettingsComponent implements OnInit{
  private subs = new SubSink();
  
  items: MenuItem[] = [
    {label: "Settings", icon: "pi-fw fas fa-tools"}, 
    {label: "Manage Roster Settings", icon: "pi-fw fas fa-cog"},
  ];

  spinnerName: string = "rosterSettingSpinner";
  spinnerText: string = "Loading roster settings ...";
  
  rosterSettings: IRosterSettings = {
    rosterProjects: [],
    roles: [],
    workGroups: [],
    employers: []
  };
  dataIsReady = false;

  private tabIndexKey = "RosterSettingActiveIndexKey";
  activeTabIndex = 0;

  constructor(
    private _rosterSettingsService: RosterSettingsService,
    private _spinner: NgxSpinnerService,
    private _authService: AuthenticationService){
  }

  ngOnInit(){
    this.activeTabIndex = +window.localStorage.getItem(this.tabIndexKey);
    this.loadRosterSettings();
  }
  
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loadRosterSettings(){
    this.dataIsReady = false;
    this._spinner.show(this.spinnerName);
    this.subs.sink = this._rosterSettingsService.getAll()
      .subscribe(res => {
        if (res.succeed){
          this.rosterSettings = res.result;
          this.dataIsReady = true;
        }
      })
      .add(
        () => {
          this._spinner.hide(this.spinnerName);
        }
      );
  }

  tabSwitched(event){
    this.activeTabIndex = event.index;
    window.localStorage.setItem(this.tabIndexKey, this.activeTabIndex + "");
  }

  /**
   * Check if current user has permission to config roster project permission.
   * @returns true with permission, false without.
   */
   canManageRosterProject(): boolean{
    return this._authService.canUserDoOperartion(BusinessOperation.ManageRosterProject);
  }
}